var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBinDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 550 628",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8114,-7985)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1.70934,2174.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.81113,0,0,2.81113,8203.09,6407.76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-138.668L12.27,-11.772C13.104,-5.04 18.825,0.014 25.608,0.01L110.908,0.01C117.715,0.007 123.445,-5.082 124.253,-11.841L136.516,-138.668L0,-138.668ZM110.951,6.396L25.565,6.396C15.555,6.393 7.128,-1.092 5.941,-11.031L-6.679,-141.584C-6.853,-143.318 -5.589,-144.865 -3.855,-145.039C-3.745,-145.05 -3.635,-145.056 -3.524,-145.055L140.062,-145.055C141.805,-145.064 143.224,-143.658 143.233,-141.916C143.234,-141.805 143.228,-141.694 143.217,-141.584L130.597,-11.101C129.437,-1.129 120.991,6.394 110.951,6.396",
    style: {
      fill: "rgb(242,242,247)",
      fillRule: "nonzero",
      stroke: "rgb(242,242,247)",
      strokeWidth: "8.89px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.81113,0,0,2.81113,8149.29,5999.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-28.283C-0.675,-28.283 -1.223,-27.738 -1.223,-27.067L-1.223,-1.213C-1.221,-0.543 -0.674,-0 0,-0L171.358,-0C172.034,-0 172.581,-0.545 172.581,-1.216L172.581,-27.067C172.581,-27.738 172.034,-28.283 171.358,-28.283L0,-28.283ZM171.438,6.387L0.377,6.387C-3.78,6.381 -7.148,3.009 -7.153,-1.152L-7.153,-27.131C-7.148,-31.292 -3.78,-34.664 0.377,-34.67L171.438,-34.67C175.594,-34.664 178.963,-31.292 178.968,-27.131L178.968,-1.149C178.961,3.011 175.593,6.381 171.438,6.387",
    style: {
      fill: "rgb(242,242,247)",
      fillRule: "nonzero",
      stroke: "rgb(242,242,247)",
      strokeWidth: "8.89px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.81113,0,0,2.81113,8315.12,5840.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,21.896L57.022,21.896L57.022,4.363C57.014,1.957 55.04,0.008 52.603,-0L4.419,-0C1.982,0.008 0.009,1.957 0,4.363L0,21.896ZM59.797,28.283L-3.23,28.283C-4.973,28.283 -6.386,26.87 -6.386,25.126L-6.386,4.313C-6.378,-1.592 -1.592,-6.378 4.314,-6.387L52.252,-6.387C58.159,-6.378 62.944,-1.592 62.953,4.313L62.953,25.126C62.953,26.87 61.54,28.283 59.797,28.283",
    style: {
      fill: "rgb(242,242,247)",
      fillRule: "nonzero",
      stroke: "rgb(242,242,247)",
      strokeWidth: "8.89px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.81113,0,0,2.81113,8307.86,6096.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,72.841C-1.62,72.84 -2.975,71.612 -3.137,70.001L-10.024,3.719C-10.233,1.988 -8.998,0.416 -7.268,0.208C-5.537,0 -3.965,1.235 -3.757,2.965C-3.753,2.998 -3.749,3.032 -3.746,3.066L3.141,69.348C3.324,71.081 2.068,72.635 0.334,72.819C0.332,72.819 0.33,72.82 0.328,72.82C0.219,72.832 0.11,72.84 0,72.841",
    style: {
      fill: "rgb(242,242,247)",
      fillRule: "nonzero",
      stroke: "rgb(242,242,247)",
      strokeWidth: "8.89px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.81113,0,0,2.81113,8385.66,6105.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,66.904L0,0.001C0,-1.501 1.003,-2.869 2.47,-3.191C4.549,-3.647 6.386,-2.076 6.386,-0.077L6.386,66.981C6.386,68.981 4.549,70.551 2.47,70.095C1.003,69.773 0,68.406 0,66.904",
    style: {
      fill: "rgb(242,242,247)",
      fillRule: "nonzero",
      stroke: "rgb(242,242,247)",
      strokeWidth: "8.89px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.81113,0,0,2.81113,8482.1,6097.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,72.783C-0.105,72.784 -0.211,72.778 -0.316,72.767C-2.049,72.588 -3.309,71.036 -3.128,69.302L-3.128,69.296L3.759,3.014C3.912,1.277 5.443,-0.006 7.179,0.146C8.916,0.299 10.2,1.83 10.047,3.566C10.044,3.6 10.041,3.634 10.037,3.668L3.15,69.949C2.984,71.563 1.622,72.789 0,72.783",
    style: {
      fill: "rgb(242,242,247)",
      fillRule: "nonzero",
      stroke: "rgb(242,242,247)",
      strokeWidth: "8.89px"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinDark);
export default __webpack_public_path__ + "static/media/bin_dark.452a812ddcffdc520a1c8df39a11bea4.svg";
export { ForwardRef as ReactComponent };